import {
  DirectionsBike,
  DirectionsBus,
  DirectionsCar,
  EuroOutlined,
  Groups,
  LocalParking,
} from '@mui/icons-material'
import type { ParseKeys } from 'i18next'
import type { JSX } from 'react'

type itemsType = {
  customIcon: JSX.Element
  itemId: string
  label: ParseKeys<'network.career_website'>
}[]

export const accessModesList: itemsType = [
  {
    customIcon: <DirectionsBus />,
    itemId: 'public_transport',
    label: 'accessModes.list.slot1',
  },
  {
    customIcon: <DirectionsCar />,
    itemId: 'car_access',
    label: 'accessModes.list.slot2',
  },
  {
    customIcon: <EuroOutlined />,
    itemId: 'transport_allowance',
    label: 'accessModes.list.slot3',
  },
  {
    customIcon: <LocalParking />,
    itemId: 'free_parking',
    label: 'accessModes.list.slot4',
  },
  {
    customIcon: <Groups />,
    itemId: 'carpooling',
    label: 'accessModes.list.slot5',
  },
  {
    customIcon: <DirectionsBike />,
    itemId: 'bike_access',
    label: 'accessModes.list.slot6',
  },
]
